
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("2zJjy"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("2zJjy", function(module, exports) {

let $1e020020bcc40937$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e020020bcc40937$var$load("h3ABO"),
    $1e020020bcc40937$var$load("5pzCW"),
    $1e020020bcc40937$var$load("9hYRW"),
    $1e020020bcc40937$var$load("kpm7S"),
    $1e020020bcc40937$var$load("5wC2D"),
    $1e020020bcc40937$var$load("2YffH"),
    $1e020020bcc40937$var$load("g7ggm"),
    $1e020020bcc40937$var$load("eEyVs"),
    $1e020020bcc40937$var$load("6mHrv"),
    $1e020020bcc40937$var$load("awWN9"),
    $1e020020bcc40937$var$load("9CYct"),
    $1e020020bcc40937$var$load("fcu8z"),
    $1e020020bcc40937$var$load("4vwhP"),
    $1e020020bcc40937$var$load("hZtKG"),
    $1e020020bcc40937$var$load("dkqvW"),
    $1e020020bcc40937$var$load("lVO3w"),
    $1e020020bcc40937$var$load("hyzoX"),
    $1e020020bcc40937$var$load("h9Ed7"),
    $1e020020bcc40937$var$load("eBRUf"),
    $1e020020bcc40937$var$load("kbRvk"),
    $1e020020bcc40937$var$load("tKhaz"),
    $1e020020bcc40937$var$load("cD6Zr"),
    $1e020020bcc40937$var$load("k3jER"),
    $1e020020bcc40937$var$load("8YSo7"),
    $1e020020bcc40937$var$load("hwT9D"),
    $1e020020bcc40937$var$load("j4Bpe"),
    $1e020020bcc40937$var$load("9XYQ9"),
    $1e020020bcc40937$var$load("50ame"),
    $1e020020bcc40937$var$load("7do1E"),
    $1e020020bcc40937$var$load("77dkW"),
    $1e020020bcc40937$var$load("1MlIV"),
    $1e020020bcc40937$var$load("6iz6l"),
    $1e020020bcc40937$var$load("4SCW2"),
    $1e020020bcc40937$var$load("eukPA"),
    $1e020020bcc40937$var$load("9QSJH"),
    $1e020020bcc40937$var$load("hv4mn"),
    $1e020020bcc40937$var$load("Wowvf"),
    $1e020020bcc40937$var$load("dek7I"),
    $1e020020bcc40937$var$load("3SmkN"),
    $1e020020bcc40937$var$load("dYtBN"),
    $1e020020bcc40937$var$load("kNV5Y"),
    $1e020020bcc40937$var$load("6wr18"),
    $1e020020bcc40937$var$load("kjZZD"),
    $1e020020bcc40937$var$load("99Ppz"),
    $1e020020bcc40937$var$load("5v2fx"),
    $1e020020bcc40937$var$load("fkb26"),
    $1e020020bcc40937$var$load("37ldp"),
    $1e020020bcc40937$var$load("ffEVr"),
    $1e020020bcc40937$var$load("9AXkC"),
    $1e020020bcc40937$var$load("28arV"),
    $1e020020bcc40937$var$load("hhss7"),
    $1e020020bcc40937$var$load("lkwGP"),
    $1e020020bcc40937$var$load("fGPXi"),
    $1e020020bcc40937$var$load("dP7ao"),
    $1e020020bcc40937$var$load("hogcU"),
    $1e020020bcc40937$var$load("dkgtP"),
    $1e020020bcc40937$var$load("g43Ev"),
    $1e020020bcc40937$var$load("7EorR"),
    $1e020020bcc40937$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.cce60136.js.map
